
export function Capitalize(inputString: string) {
  return inputString.at(0)?.toUpperCase() + inputString.toLowerCase().slice(1);
}

export function CapitalizeAll(inputString: string) {
  return inputString.split(" ").map(s => Capitalize(s)).join(" ");
}
